import React, { Fragment } from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import projectStyle from "../../JSComponents/styles/Project.module.scss";
import Project from "../../shared/Project";
import { InvestmentsList } from "../organisms/InvestmentsList";
import { ColumnFlexBox } from "../templates/Wrappers";
import { interestCalc } from "../../shared/BusinessIntelligence";
import NewInvestmentInput from "../atoms/NewInvestmentInput";
import { lang } from "../../globals/Translations";
import { TranslatedTerms } from "../../globals/TranslatedTerms";
import ReactMarkdown from 'react-markdown';
import { NiceIntrestRate, NiceNumberWithCurrency } from "../../shared/UIFormatting";



const WhatsInItForMe: React.FC<{ project?: Project }> = ({ project }) => {
  if (!project) return <></>

  const interestRate = project.finance.interestRate
  const investmentMinimum = project.finance.minimumInvestment
  const durationMin = project.finance.durationMin
  const durationMax = project.finance.durationMax

  const [value, setValue] = React.useState<number>(investmentMinimum)

  const profitMin = interestCalc(value, interestRate, durationMin);
  const profitMax = interestCalc(value, interestRate, durationMax);

  let message = lang(TranslatedTerms.IN_X_MONTHS_YOU_WILL_HAVE_RECIVED_X_AMOUNT_NOT_BAD_HUH)
  message = message.split("{durationMin}").join("**" + durationMin)
  message = message.split("{durationMax}").join(durationMax + "**")
  message = message.split("{profitMin}").join("**" + NiceNumberWithCurrency(profitMin - value))
  message = message.split("{profitMax}").join(NiceNumberWithCurrency(profitMax - value) + "**")

  return (
    <Fragment>
      <h4>{lang(TranslatedTerms.DESIRED_LENDING_AMOUNT)}</h4>
      <NewInvestmentInput project={project} setValue={setValue} />

      <ReactMarkdown children={message} />
      <ColumnFlexBox style={{ marginTop: 20 }}>
        <InvestmentsList project={project} />
      </ColumnFlexBox>


      <Accordion style={{ marginTop: 20 }}>
        <AccordionSummary>{lang(TranslatedTerms.VIEW_DETAILS)}</AccordionSummary>
        <AccordionDetails>
          <div className={projectStyle.dlListContainer}>
            <dl className={projectStyle.dlList}>
              <dt>{lang(TranslatedTerms.MIN_INVESTMENT)}</dt><dd>{NiceNumberWithCurrency(investmentMinimum)}</dd>
              <dt>{lang(TranslatedTerms.INTEREST_RATE_PR_Y)}</dt><dd>{NiceIntrestRate(interestRate, true)}</dd>
              <dt>{lang(TranslatedTerms.DURATION)}</dt><dd>{durationMin} - {durationMax} {lang(TranslatedTerms.MTH).toLocaleLowerCase()}</dd>
              <dt>{lang(TranslatedTerms.PRINCIPAL)}</dt><dd>{NiceNumberWithCurrency(value)}</dd>
              <dt>{lang(TranslatedTerms.INTREST_REVENUE)}</dt><dd>{NiceNumberWithCurrency(profitMin - value)} - {NiceNumberWithCurrency(profitMax - value)}</dd>
            </dl>
          </div>
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

export default WhatsInItForMe;
